import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "varnish",
  "use": "varnish-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"varnish\"><path d=\"M13.165 8.533a3.766 3.766 0 1 0 0-7.531 3.766 3.766 0 0 0 0 7.531M7.197 17.001a2.72 2.72 0 1 0 0-5.44 2.72 2.72 0 0 0 0 5.44M2.638 9.656a1.564 1.564 0 1 0 0-3.127 1.564 1.564 0 0 0 0 3.127\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol